<template>
  <common-dialog
    ref="dialog"
    title="New Shipment Note"
    :width="30"
    :inputs-map="newNote"
    :input-value-change="valueChange"
    :save-cb="saveNewNote"
    :reset-inputs="resetInputs"
  >
  </common-dialog>
</template>
<script>
// others
import cloneDeep from 'lodash/cloneDeep'
// models
import { ShipmentNoteForm } from '@/core/models/note'
// mixin
import { dialogMixin } from '@/core/mixin/dialog'
// components
import CommonDialog from '@/components/common/CommonDialog.vue'
export default {
  name: 'ShipmentNoteNew',
  mixins: [dialogMixin],
  props: {
    addressGroups: {
      type: Array,
      required: true
    }
  },
  components: {
    CommonDialog
  },
  watch: {
    addressGroups() {
      this.newNote[0].options = this.addressGroups
    }
  },
  data() {
    return {
      newNote: Object.values(cloneDeep(ShipmentNoteForm)),
      saveCb: null
    }
  },
  methods: {
    saveNewNote(info, done, error) {
      // todo 需要检查 输入的东西是否正确
      const group = this.addressGroups.find(one => one.key === info.palletGroup)
      info.orderId = group?.orderId ?? undefined
      info.addressId = group?.address?.id ?? undefined
      delete info.palletGroup
      info.createdTime = new Date().toISOString()
      this.saveCb(info, done, error)
    },
    open(saveCb = null) {
      this.$refs.dialog.open()
      this.saveCb = saveCb
    },
    resetInputs() {
      this.$set(this, 'newNote', Object.values(cloneDeep(ShipmentNoteForm)))
      this.newNote[0].options = this.addressGroups
    },
    valueChange(key, val) {
      if (key === 'containerNo') {
        const address = this.addressGroups?.[val].address ?? []
        this.newNote[1].options = address
      }
    },
    close() {
      this.$refs.dialog.close()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';
</style>
